import { FC, useContext, useEffect, useState } from 'react';

// import TicketsViewSwitcher from './components/TicketsViewSwitcher';
// import { useTickets } from 'contexts/TicketsContext';
import {
  BtnFlexContainerStyled,
  ButtonStyled,
  ClearBtnIconStyled,
  ClearBtnWrapStyled,
  FlexContainerStyled,
  HeaderStyled,
  InputStyled,
  MobileContainerStyled,
  TypographyStyled,
} from './Header.styled';
import useHeader from './hooks/useHeader';
import { RO_REQUEST_TIP } from 'constants/repairOrder';
import { useResponsive } from 'contexts/ResponsiveContext';
import { TicketsContext } from 'contexts/TicketsContext';
import { ActiveTabTypeE } from 'declarations/enums/tab';
import { TicketsRefinementKeysE } from 'declarations/enums/tickets';
import { CloseIcon, SearchIcon } from 'icons';

const Header: FC = () => {
  const {
    onChangeInput,
    searchText,
    openNewTicketPopup,
    openROListPopup,
    resetSearchTerm,
    handleExportClick,
    isExportingTickets,
  } = useHeader();
  const { isMobile } = useResponsive();
  const { getSearchParam, activeTab } = useContext(TicketsContext);
  // const { setTicketsViewMode, ticketsViewMode } = useTickets();
  const [isRoofTopFiltered, setIsRoofTopFiltered] = useState(false);

  useEffect(() => {
    setIsRoofTopFiltered(getSearchParam(TicketsRefinementKeysE.RoofTopId) !== null ? true : false);
  }, [getSearchParam, isRoofTopFiltered, setIsRoofTopFiltered]);

  return (
    <HeaderStyled>
      {/* <TicketsViewSwitcher ticketsViewMode={ticketsViewMode} onSwitchView={setTicketsViewMode} /> */}
      <FlexContainerStyled
        direction={isMobile ? 'column' : 'row'}
        align={isMobile ? 'start' : 'center'}
      >
        <MobileContainerStyled
          direction={isMobile ? 'column' : 'row'}
          align={isMobile ? 'start' : 'center'}
        >
          {isMobile ? (
            <MobileContainerStyled justify="between">
              <TypographyStyled variant="h2" color="darkBlue">
                All Tickets
              </TypographyStyled>
            </MobileContainerStyled>
          ) : (
            <TypographyStyled variant="h2" color="darkBlue">
              All Tickets
            </TypographyStyled>
          )}
          <div style={{ position: 'relative' }} title="Search for RO, Tech, Advisor...">
            <InputStyled
              id="searchTerm"
              name="searchTerm"
              icon={<SearchIcon />}
              placeholder="Search for RO, Tech, Advisor..."
              value={searchText}
              onChange={onChangeInput}
              bg="grey"
            />
            {searchText && (
              <ClearBtnWrapStyled justify="center">
                <ClearBtnIconStyled
                  size="md"
                  variant="transparent"
                  icon={<CloseIcon size="xs" />}
                  onClick={resetSearchTerm}
                />
              </ClearBtnWrapStyled>
            )}
          </div>
        </MobileContainerStyled>
        <BtnFlexContainerStyled>
          <ButtonStyled
            size="md"
            variant="outline"
            className="open-ro-list-btn"
            onClick={openROListPopup}
            disabled={!isRoofTopFiltered}
            title={RO_REQUEST_TIP}
          >
            Send RO's to WarrCloud
          </ButtonStyled>
          <ButtonStyled
            size="md"
            variant="outline"
            className="share-template"
            onClick={handleExportClick}
            isLoading={isExportingTickets}
            loaderColor="darkBlue"
            loaderVariant="brick"
          >
            Export
          </ButtonStyled>
          {activeTab === ActiveTabTypeE.Tickets && (
            <ButtonStyled
              size="md"
              variant="contained"
              onClick={openNewTicketPopup}
              className="open-ticket-btn"
            >
              New Ticket
            </ButtonStyled>
          )}
        </BtnFlexContainerStyled>
      </FlexContainerStyled>
    </HeaderStyled>
  );
};

export default Header;
